import { getSchedulerDataServicesRepair, getSchedulerDataServicesInstall, getSchedulerDataServicesMaintenance } from "../services";
import { filteredServicesComponents } from "../filteredServicesComponent"
export function gasAndGasLines (){

    let servicesStart =  [
        {
          id: "Gas Leak Detection & Repair",
          remType: "repair",
          label: <>Gas Leak Detection & Repair</>,
          jobType: "Gas Leak",
          note: (
            <>
              If applicable, please contact your gas company to have
              your gas shut off prior to scheduling with us."
            </>
          ),
          data: [],
        },
        {
          id: "Gas Line Installation",
          remType: "estimate",
          label: <>Gas Line Installation </>,
          jobType: "Gas Line",
          data: [],
        },
      ]
      let response = []

      servicesStart.map((services) => {
        if (services.remType == "estimate") {
          let serviceArray = []
          serviceArray.push(services)
          response.push(filteredServicesComponents(serviceArray, getSchedulerDataServicesInstall)[0])
        } else if (services.remType == "repair") {
          let serviceArray = []
          serviceArray.push(services)
          response.push(filteredServicesComponents(serviceArray, getSchedulerDataServicesRepair)[0])
        } else if (services.remType == "maintenance") {
          let serviceArray = []
          serviceArray.push(services)
          response.push(filteredServicesComponents(serviceArray, getSchedulerDataServicesMaintenance)[0])
        }
    
    
      })
      return response

}